export class OrderDetailsGeneralCancelRequest {

    constructor(private cancellationMotive: string) {
    }
}
